module.exports = __webpack_public_path__ + "media/images/lp/industries/solution-03-fe51760beeb77856b7c5a8e05f0559ec.png";